import { useContext } from "react";
import { Button, Typography } from "@material-ui/core";
import { AuthContext } from "context/context";
import { InputFile } from "../../../altaRiesgo16/components/fields";
import { CancelacionMasivaContext } from "../../../../../context";
import useStyles from "./styles";

export const UploadPolizas = ({ returnToMain }) => {
  const classes = useStyles();
  const { setTimer } = useContext(AuthContext);
  const { file, setFile } = useContext(CancelacionMasivaContext);

  const handleChange = (files) => {
    setTimer(0);
    setFile(files[0]);
  };

  return (
    <div>
      <Typography className={classes.title} variant="h6">
        Agregar archivo de pólizas
      </Typography>
      <InputFile
        required
        label="Archivo de pólizas"
        onChange={handleChange}
        name={file?.name}
      />
      <Typography className={classes.caption} variant="caption">
        Recuerda que solo se permiten documentos excel (.xlsx)
      </Typography>
      <Button
        className={classes.backButton}
        variant="text"
        onClick={() => {
          setTimer(0);
          returnToMain();
        }}
      >
        Regresar
      </Button>
    </div>
  );
};
